<template>
  <div class="w-full min-h-screen">

    <nav-bar-styled
      class="w-full px-4 border-b border-opacity-50 border-secundario-12"
      :colorP="color_principal"
    >
      <div class="flex items-center justify-between gap-8">
        <div class="flex items-center gap-2 lg:gap-8">
          <img
            src="@/assets/logos-instituciones/logo_gobmx.svg"
            class="h-6 lg:h-10"
            alt="Gobierno de México"
          />
          <img
            src="@/assets/logos-instituciones/bienestar.png"
            class="h-4 lg:h-8"
            alt="Gobierno de México"
          />
          <img
            src="@/assets/logos-instituciones/sembrando-vida.png"
            class="h-6 lg:h-10"
            alt="Gobierno de México"
          />
        </div>

        <div class="flex w-7/12 lg:w-8/12 items-center justify-end gap-2">
          <div class="relative group">
            <div
              data-v-step="notifications"
              class=""
            >
              <link-styled
                v-on:click="showDropdown"
                href="#"
                class="flex items-center justify-center p-2 text-white rounded-full cursor-pointer"
                :colorS="color_secundario"
                aria-label="Notificaciones"
              >
                <svg
                  class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 122.88 122.83"
                  aria-hidden="true"
                >
                  <path
                    d="M73.81,7.47A43.14,43.14,0,0,1,92.69,19.35a42.33,42.33,0,0,1,10.76,21.36l0,.28c.21,1.21.36,2.36.45,3.44.11,1.26.17,2.53.17,3.8h0V58.36c0,2.81,0,5.67.2,8.54a32.41,32.41,0,0,0,4.34,14.62A36.6,36.6,0,0,0,120,92.83a6.34,6.34,0,0,1,2.65,3.65,6.52,6.52,0,0,1-.08,3.56,6.62,6.62,0,0,1-1.91,3,6.33,6.33,0,0,1-4.25,1.57H82.27l0,.08h0c-4.14,24.2-37.61,24.13-41.65-.08H6.45A6.33,6.33,0,0,1,2,102.92a6.6,6.6,0,0,1-1.81-6.5A6.33,6.33,0,0,1,3,92.71c5.66-3.83,9.62-8,12.12-12.76s3.65-10.44,3.65-17.28V48.23c0-1.16.06-2.42.18-3.77s.29-2.52.51-3.76A42.89,42.89,0,0,1,49.39,7.41C54-2.47,69.2-2.49,73.81,7.47ZM87.71,24A36.34,36.34,0,0,0,70.38,13.57,3.42,3.42,0,0,1,68,11.22c-1.71-5.87-11-6-12.72-.05a3.43,3.43,0,0,1-2.48,2.38A36.1,36.1,0,0,0,26.15,41.9q-.28,1.58-.42,3.15c-.09,1-.13,2-.13,3.18V62.67c0,7.91-1.38,14.56-4.45,20.43-2.94,5.62-7.36,10.39-13.54,14.72H115.27A42.38,42.38,0,0,1,102.8,85,39.18,39.18,0,0,1,97.5,67.4c-.22-2.88-.21-6-.2-9V48.23h0c0-1.1,0-2.17-.13-3.22s-.21-2-.36-2.85l-.06-.27a35.62,35.62,0,0,0-9-17.9Z"
                  />
                </svg>
                <div
                  v-if="
                    raising.length > 0 ||
                    curator_raising.length > 0 ||
                    projects.length > 0 ||
                    curator_projects.length > 0 ||
                    listDownload.length > 0
                  "
                  class="rounded-full w-2 h-2 bg-white"
                ></div>
              </link-styled>
            </div>
            <div
              id="dropdown"
              class="absolute right-0 mt-0 py-4 w-auto lg:w-64 bg-white rounded-lg shadow-xl hidden z-20"
            >
              <div v-if="raising.length > 0 || curator_raising.length > 0">
                <p class="px-4">Levantamientos</p>
                <ul class="text-sm">
                  <li 
                    v-for="one_raising in raising" :key="one_raising.id"
                    class="my-1"
                  >
                    <router-link
                      :to="{
                        name: 'viewRaising',
                        query: { id: one_raising.id, name: one_raising.title }
                      }"
                      @click.native="updateListRaising(one_raising.id)"
                      class="block cursor-pointer py-2 px-8 text-gray-900 hover:bg-primary-color hover:text-white"
                    >
                      <p>{{ one_raising.title }}</p>
                      <p>{{ one_raising.fecha_levantamiento | moment("DD/MM/YYYY hh:mm A") }}</p>
                      <p>F-{{ one_raising.id }} {{ one_raising.status }}</p>
                      <p class="text-xs">{{ one_raising.cat_principal }}</p>
                      <p class="text-xs">{{ one_raising.cat_secundaria }}</p>
                    </router-link>
                  </li>
  
                  <li v-for="one_raising in curator_raising" :key="one_raising.id">
                    <router-link
                      :to="{
                        name: 'viewRaisingEvaluation',
                        query: { id: one_raising.id, name: one_raising.title }
                      }"
                      @click.native="updateListRaising(one_raising.id)"
                      class="block cursor-pointer py-2 px-8 text-gray-900 hover:bg-primary-color hover:text-white"
                    >
                      <p>{{ one_raising.title }}</p>
                      <p>{{
                        one_raising.fecha_levantamiento
                          | moment("DD/MM/YYYY hh:mm A")
                      }}</p>
                      <p>F-{{ one_raising.id }} {{ one_raising.status }}</p>
                      <p class="text-xs">{{ one_raising.cat_principal }}</p>
                      <p class="text-xs">{{ one_raising.cat_secundaria }}</p>
                    </router-link>
                  </li>
                </ul>
              </div>

              <div v-if="projects.length > 0 || curator_projects.length > 0">
                <p class="px-4">Proyectos</p>
                <ul class="text-sm">
                  <li v-for="one_project in projects" :key="one_project.id">
                    <router-link
                      :to="{
                        name: 'viewProject',
                        query: { id: one_project.id, name: one_project.title }
                      }"
                      @click.native="updateListProject(one_project.id)"
                      class="block cursor-pointer py-2 px-8 text-gray-900 hover:bg-primary-color hover:text-white"
                    >
                      <p>{{ one_project.title }}</p>
                      <p>{{ one_project.fecha_creacion | moment("DD/MM/YYYY hh:mm A") }}</p>
                      <p>F-{{ one_project.id }} {{ one_project.status }}</p>
                      <p class="text-xs">{{ one_project.cat_principal }}</p>
                      <p class="text-xs">{{ one_project.cat_secundaria }}</p>
                    </router-link>
                  </li>
                  <li v-for="one_project in curator_projects" :key="one_project.id">
                    <router-link
                      :to="{
                        name: 'viewProjectEvaluation',
                        query: { id: one_project.id, name: one_project.title }
                      }"
                      @click.native="updateListProject(one_project.id)"
                      class="block cursor-pointer py-2 px-8 text-gray-900 hover:bg-primary-color hover:text-white"
                    >
                      <p>{{ one_project.title }}</p>
                      <p>{{ one_project.fecha_creacion | moment("DD/MM/YYYY hh:mm A") }}</p>
                      <p>F-{{ one_project.id }} {{ one_project.status }}</p>
                      <p class="text-xs">{{ one_project.cat_principal }}</p>
                      <p class="text-xs">{{ one_project.cat_secundaria }}</p>
                    </router-link>
                  </li>
                </ul>
              </div>

              <div v-if="listDownload.length > 0">
                <p class="px-4">Descargas</p>
                <ul class="text-sm">
                  <li v-for="one_download in listDownload" :key="one_download.id">
                    <router-link
                      :to="{
                        name: 'viewDownload',
                        query: { id: one_download.id, name: one_download.title }
                      }"
                      @click.native="updateListDownload(one_download.id)"
                      class="block cursor-pointer py-2 px-8 text-gray-900 hover:bg-primary-color hover:text-white"
                    >
                      <p>{{ one_download.title }}</p>
                      <p>{{ one_download.fecha_solicitud | moment("DD/MM/YYYY hh:mm A") }}</p>
                      <p class="text-sm">F-{{ one_download.id }} {{ one_download.status }}</p>
                    </router-link>
                  </li>
                </ul>
              </div>

              <p
                class="px-4 text-center text-gray-800"
                v-if="
                  raising.length == 0 &&
                  curator_raising.length == 0 &&
                  projects.length == 0 &&
                  listDownload.length == 0 &&
                  curator_projects.length == 0
                "
              >
                No hay notificaciones
              </p>
            </div>
          </div>

          <div class="relative group">
            <div class="flex items-center p-2 cursor-pointer gap-2 text-white">
              <img
                class="h-8 w-8 rounded-full"
                :src="profile_image"
                @error="defaultProfile"
              />
              <p class="font-semibold text-sm lg:text-base">
                {{ user }}
                <span class="block text-xs lg:text-sm font-normal">
                  {{ category }}
                </span>
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M7 10l5 5 5-5z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </div>
            
            <div
              class="absolute right-0 mt-0 py-2 w-48 bg-white rounded-lg shadow-xl text-left hidden group-hover:block z-20"
            >
              <link-hover-styled
                v-on:click="updateProfileModal"
                href="#"
                class="flex items-center gap-2 px-4 py-2 text-gray-800 hover:text-white font-semibold"
                :colorS="color_secundario"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                  />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
                Perfil
              </link-hover-styled>
              <link-hover-styled
                @click="dologout"
                href="#"
                class="flex items-center gap-2 px-4 py-2 text-gray-800 hover:text-white font-semibold"
                :colorS="color_secundario"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                  />
                </svg>
                Cerrar sesión
              </link-hover-styled>
            </div>
          </div>
        </div>
      </div>
    </nav-bar-styled>

    <div class="flex flex-col lg:flex-row altura-contenedor">
      <div class="flex lg:flex-col w-full lg:w-56 lg:h-full bg-white overflow-x-auto lg:overflow-y-auto text-center lg:text-left">
        
        <ul class="flex flex-row lg:flex-col text-sm lg:text-base border-b">
          <li-separator-styled
            class="p-4 lg:pt-8 lg:pb-6 h-full flex items-center font-semibold  border-r lg:border-0"
          >
            Consulta
          </li-separator-styled>

          <li-hover-styled
            :colorS="color_secundario"
          >
            <router-link
              data-v-step="map"
              to="/explorer"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"/>
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              Mapa
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            :colorS="color_secundario"
            v-if="category == 'ADMINISTRADOR'"
          >
            <router-link
              to="/gallery"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 -960 960 960"
                aria-hidden="true"
              >
                <path
                  d="M360-400h400L622-580l-92 120-62-80-108 140Zm-40 160q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Z"
                />
              </svg>
              Galería
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            :colorS="color_secundario"
            v-if="category == 'ADMINISTRADOR'"
          >
            <router-link
              to="/users"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 -960 960 960"
                aria-hidden="true"
              >
                <path
                  d="M160-40v-80h640v80H160Zm0-800v-80h640v80H160Zm320 400q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm70-80q45-56 109-88t141-32q77 0 141 32t109 88h70v-480H160v480h70Zm118 0h264q-29-20-62.5-30T480-280q-36 0-69.5 10T348-240Zm132-280q-17 0-28.5-11.5T440-560q0-17 11.5-28.5T480-600q17 0 28.5 11.5T520-560q0 17-11.5 28.5T480-520Zm0 40Z"
                />
              </svg>
              Usuarios
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            :colorS="color_secundario"
            v-if="category == 'ADMINISTRADOR'"
          >
            <router-link
              to="/explora"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 -960 960 960"
                aria-hidden="true"
              >
                <path
                  d="m720-430 80 80v190q0 33-23.5 56.5T720-80H160q-33 0-56.5-23.5T80-160v-560q0-33 23.5-56.5T160-800h220q-8 18-12 38.5t-6 41.5H160v560h560v-270Zm52-174 128 128-56 56-128-128q-21 12-45 20t-51 8q-75 0-127.5-52.5T440-700q0-75 52.5-127.5T620-880q75 0 127.5 52.5T800-700q0 27-8 51t-20 45Zm-152 4q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM160-430v270-560 280-12 22Z"
                />
              </svg>
              Explora y aporta
            </router-link>
          </li-hover-styled>
        </ul>

        <ul class="flex flex-row lg:flex-col text-sm lg:text-base border-b">
          <li-separator-styled
            class="p-4 lg:pt-8 lg:pb-6 h-full flex items-center font-semibold  border-r lg:border-0"
          >
            Mis actividades
          </li-separator-styled>

          <li-hover-styled
            :colorS="color_secundario"
            v-if="category == 'ADMINISTRADOR'"
          >
            <router-link
              data-v-step="projects"
              to="/proyectos"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 384 512"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                />
              </svg>
              Mis proyectos
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            :colorS="color_secundario"
          >
            <router-link
              data-v-step="fichas"
              to="/userRaising"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M3 19V5H21V19ZM5 9H7V7H5ZM9 9H19V7H9ZM9 13H19V11H9ZM9 17H19V15H9ZM5 17H7V15H5ZM5 13H7V11H5Z"/>
              </svg>
              Mis aportes
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            :colorS="color_secundario"
            v-if="category === 'ADMINISTRADOR'"
          >
            <router-link
              data-v-step="downloads"
              to="/download"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 -960 960 960"
                aria-hidden="true"
              >
                <path
                  d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
                />
              </svg>
              Mis descargas
            </router-link>
          </li-hover-styled>
        </ul>

        <ul class="flex flex-row lg:flex-col text-sm lg:text-base border-b">
          <li-separator-styled
            v-if="category === 'ADMINISTRADOR' || category === 'LIDER DE PROYECTO' || category === 'REVISOR'"
            class="p-4 lg:pt-8 lg:pb-6 h-full flex items-center font-semibold  border-r lg:border-0"
          >
            Administración
          </li-separator-styled>

          <li-hover-styled
            v-if="category == 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/userList"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z" />
                <path fill="none" d="M0 0h24v24H0z" />
              </svg>
              Usuarios
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category === 'ADMINISTRADOR' || category === 'LIDER DE PROYECTO'"
            :colorS="color_secundario"
          >
            <router-link
              to="/guestUserList"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              Invitaciones
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category === 'REVISOR' || category === 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/raising"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 -960 960 960"
                aria-hidden="true"
              >
                <path d="M280-280h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/>
              </svg>
              Revisión de aportes
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category === 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/estadisticas"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <g>
                  <rect fill="none" height="24" width="24" />
                  <g>
                    <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z"/>
                    <rect height="5" width="2" x="7" y="12" />
                    <rect height="10" width="2" x="15" y="7" />
                    <rect height="3" width="2" x="11" y="14" />
                    <rect height="2" width="2" x="11" y="10" />
                  </g>
                </g>
              </svg>
              Estadísticas
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category == 'REVISOR' || category == 'LIDER DE PROYECTO' || category == 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/proyectosTodos"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 0 384 512"
                aria-hidden="true"
              >
                <path
                  d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                />
              </svg>
              Proyectos
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category === 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/projectEvaluation"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                aria-hidden="true"
              >
                <path
                  d="m313-305 198-198-57-57-141 142-57-57-56 57 113 113Zm263 0 64-64 64 64 56-56-64-64 64-64-56-56-64 64-64-64-56 56 64 64-64 64 56 56ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z"
                />
              </svg>
              Revisión de proyectos
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category === 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/downloadEvaluation"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 lg:h-6 w-4 lg:w-6 fill-current"
                viewBox="0 -960 960 960"
                aria-hidden="true"
              >
                <path
                  d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
                />
              </svg>
              Revisión de descargas
            </router-link>
          </li-hover-styled>

          <li-hover-styled
            v-if="category == 'ADMINISTRADOR'"
            :colorS="color_secundario"
          >
            <router-link
              to="/configuracion"
              class="h-full p-4 flex flex-col gap-1 lg:gap-2 lg:flex-row items-center justify-center lg:justify-start text-gray-900 hover:text-white border-r lg:border-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                />
              </svg>
              Configuración
            </router-link>
          </li-hover-styled>

        </ul>
      </div>

      <div class="flex-1 altura-contenedor bg-brd-color">
        <keep-alive include="Map">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </div>
    </div>

    <profile-modal
      :showing="showProfileModal"
      @close="closeProfileModal"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></profile-modal>

    <loading-page v-if="isLoading"></loading-page>

    <v-tour
      name="myTour"
      :steps="steps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Router from "vue-router";
import Map from "./Map";
import FormList from "./FormList";
import FormBuilder from "./FormBuilder";
import FormEditBuilder from "./FormEditBuilder";
import UserList from "./UserList";
import MonitorsList from "./MonitorsList";
import PlacesList from "./PlacesList";
import profileModal from "./ProfileModal";
import AlertList from "./AlertList";
import EventBus from "../event-bus";
import LoadingPage from "./LoadingPage";

import { styled } from "@egoist/vue-emotion";

const NavBarStyled = styled("nav")`
  background-color: ${props => props.colorP};
`;

const LinkStyled = styled("a")`
  background-color: ${props => props.colorS};
`;

const LinkHoverStyled = styled("a")`
  &:hover {
    background-color: ${props => props.colorS};
  }
`;

const LiSeparatorStyled = styled("li")`
  background-color: ${props => props.colorP};
`;

const LiHoverStyled = styled("li")`
  &:hover {
    background-color: ${props => props.colorS};
  }
  & > .router-link-active {
    background-color: ${props => props.colorS};
    color: #ffffff;
  }
`;

export default {
  name: "dashboard",
  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      raising: [],
      curator_raising: [],
      projects: [],
      curator_projects: [],
      listDownload: [],
      user: localStorage.getItem("name"),
      category: window.atob(localStorage.getItem("category")),
      profile_image: localStorage.getItem("profile_image"),
      showProfileModal: false,
      isLoading: false,
      steps: [
        {
          target: '[data-v-step="map"]',
          content:
            "Selecciona esta pestaña para consultar en el mapa los registros públicos realizados por todos los usuarios.",
          params: {
            placement: "right"
          },
          offset: -200
        },
        {
          target: '[data-v-step="fichas"]',
          content: "Revisa los aportes de registro que has aportado.",
          params: {
            placement: "right"
          },
          offset: -200
        },
        {
          target: '[data-v-step="newRegister"]',
          content: "Dando clic aquí puedes agregar un nuevo aporte.",
          params: {
            placement: "right"
          },
          offset: -200
        },
        {
          target: '[data-v-step="projects"]',
          content: "Crea y revisa tus propios proyectos.",
          params: {
            placement: "right"
          },
          offset: -200
        },
        // {
        //   target: '[data-v-step="downloads"]',
        //   content: "En esta parte puedes ver las descargas que has solicitado.",
        //   params: {
        //     placement: "right"
        //   },
        //   offset: -200
        // },
        {
          target: '[data-v-step="notifications"]',
          content:
            "En esta sección puedes revisar las notificaciones sobre el estado de tus aportes y/o mensajes de los revisores.",
          params: {
            placement: "bottom"
          },
          offset: -200
        }
      ],
      tourOptions: {
        labels: {
          buttonSkip: "Saltar",
          buttonPrevious: "Anterior",
          buttonNext: "Siguiente",
          buttonStop: "Salir"
        }
      },
      tourCallbacks: {
        onStart: this.onStartTour,
        onPreviousStep: this.onPreviousTour,
        onNextStep: this.onNextTour,
        onFinish: this.onFinishTour,
        onSkip: this.onFinishTour
      },
      color_principal: "",
      color_secundario: "",
      color_terciario: ""
    };
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"])
  },
  components: {
    profileModal,
    LoadingPage,
    NavBarStyled,
    LinkStyled,
    LinkHoverStyled,
    LiSeparatorStyled,
    LiHoverStyled
  },
  methods: {
    ...mapActions(["logout"]),
    dologout: function () {
      this.logout({});
    },
    getProfileImage: function () {
      if (this.profile_image.includes("null")) {
        this.profile_image =
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
      }
    },
    updateProfileModal: function () {
      this.showProfileModal = true;
    },
    closeProfileModal: function () {
      this.showProfileModal = false;
      this.profile_image = localStorage.getItem("profile_image");
    },
    defaultProfile: function () {
      this.profile_image =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    showDropdown() {
      if (document.querySelector("#dropdown").classList.contains("block")) {
        document.querySelector("#dropdown").classList.remove("block");
        document.querySelector("#dropdown").classList.add("hidden");
      } else {
        document.querySelector("#dropdown").classList.add("block");
        document.querySelector("#dropdown").classList.remove("hidden");
      }
    },
    fetchNotifications() {
      this.axios
        .post(
          "../apidev/levantamientos/getNotifications",
          {
            email: localStorage.getItem("email")
          },
          this.config
        )
        .then(response => {
          this.raising = response.data.levantamientos;
          return this.axios.post(
            "../apidev/levantamientos/getCuratorNotifications",
            {
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.curator_raising = response.data.levantamientos;
          return this.axios.post(
            "../apidev/projects/getNotifications",
            {
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.projects = response.data.projects;
          return this.axios.post(
            "../apidev/projects/getCuratorNotifications",
            {
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.curator_projects = response.data.projects;
          return this.axios.post(
            "../apidev/downloads/getNotifications",
            {
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.listDownload = response.data.list;
        })
        .catch(error => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    updateListRaising(id) {
      this.axios
        .post(
          "../apidev/levantamientos/updateNotification",
          {
            id_levantamiento: id
          },
          this.config
        )
        .then(() => {
          this.fetchNotifications();
        })
        .catch(error => this.catchError(error));

      this.showDropdown();
    },
    updateListProject(id) {
      this.axios
        .post(
          "../apidev/projects/updateNotification",
          {
            id: id
          },
          this.config
        )
        .then(() => {
          this.fetchNotifications();
        })
        .catch(error => this.catchError(error));

      this.showDropdown();
    },
    updateListDownload(id) {
      this.axios
        .post(
          "../apidev/downloads/updateNotification",
          {
            id: id
          },
          this.config
        )
        .then(() => {
          this.fetchNotifications();
        })
        .catch(error => this.catchError(error));

      this.showDropdown();
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
    },
    onStartTour() {
      let currentRoute = this.$route.name;
      if (currentRoute !== "explorer") {
        this.$router.push({ path: "/explorer" });
      }
    },
    onPreviousTour(current) {
      switch (current) {
        case 3:
          this.$router.push({ path: "/explorer" });
          break;
        case 2:
          this.$router.push({ path: "/proyectos" });
          break;
        case 1:
          this.$router.push({ path: "/userRaising" });
          break;
        /* case 3:
          this.$router.push({ path: "/estadisticasUser" });
          break; */
        
        default:
          break;
      }
    },
    onNextTour(current) {
      switch (current) {
        case 0:
          this.$router.push({ path: "/explorer" });
          break;
        /* case 0:
          this.$router.push({ path: "/mapa" });
          break; */
        case 2:
          this.$router.push({ path: "/userRaising" });
          break;
        /* case 1:
          this.$router.push({ path: "/estadisticasUser" });
          break; */
        case 1:
          this.$router.push({ path: "/proyectos" });
          break;
        // case 3:
        //   this.$router.push({ path: "/download" });
        //   break;
        default:
          break;
      }
    },
    onFinishTour() {
      localStorage.setItem("tour", "tourFinished");
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then(response => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    }
  },
  beforeMount() {
    this.fetchConfiguration();
  },
  mounted() {
    EventBus.$on("updateNotification", this.fetchNotifications);
    this.fetchNotifications();
    this.getProfileImage();

    this.$root.$on("showLoading", () => {
      this.isLoading = true;
    });

    this.$root.$on("hideLoading", () => {
      this.isLoading = false;
    });

    // TODO: conectar el tour.. con las vistas publicas de todos?
    // let tour = localStorage.getItem("tour");
    // if (tour !== "tourFinished") {
    //   this.$tours["myTour"].start();
    // }
  }
};
</script>
